import type { MantineThemeOverride } from "@mantine/core";

export const MantineTheme: MantineThemeOverride = {
  breakpoints: {
    lg: 1275,
    md: 1024,
    sm: 768,
    xl: 1800,
    xs: 375,
  },
  colors: {
    primary: [
      "#00A5B9",
      "#00A5B9",
      "#00A5B9",
      "#00A5B9",
      "#00A5B9",
      "#00A5B9",
      "#00A5B9",
    ],
  },
  primaryColor: "primary",
};
